export class AddressBase {

  city: string | AddressItem;
  street: string | AddressItem;
  county?: string;
  flatNumber: string;
  countryCode: string;
  buildingNumber: string;
  postalCode?: string;

  constructor() {
    this.buildingNumber = '';
    this.flatNumber = '';
    this.countryCode = 'PL';
  }
}

export interface AddressItem {
  id?: number;
  name: string;
}
